(function ($) {
  DJ.addBehavior('gallerySlider', '.gallery-slider', {
    attach: function () {
      const sliderHolder = this;
      const slider = sliderHolder.querySelector('.gallery-slider__slider');
      const sliderThumbnails = sliderHolder.querySelector('.gallery-slider__thumbnails');
      const sliderThumbnailsItems = sliderHolder.querySelectorAll('.gallery-slider__thumbnails-item');
      const $slider = $(slider);
      const $sliderThumbnails = $(sliderThumbnails);
      let sliderThumbToShow = 4;

      if (!slider) {
        return;
      }

      if (sliderThumbnailsItems && sliderThumbnailsItems.length <= 3) {
        sliderThumbToShow = 3;
      }

      /**
       * Slider options.
       */
      const sliderOptions = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        useCSS: false
      };

      const sliderThumbnailsOptions = {
        infinite: false,
        slidesToShow: sliderThumbToShow,
        slidesToScroll: sliderThumbToShow,
        vertical: true,
        arrows: true,
        useCSS: false,
        prevArrow: `<button type="button" class="slick-prev">
                    </button>`,
        nextArrow: `<button type="button" class="slick-next">
                    </button>`
      };

      /**
       * Init thumbnails slider depending on window size.
       */
      const sliderThumbnailsInit = () => {
        if (window.innerWidth < 1024 && $sliderThumbnails.hasClass('slick-initialized')) {
          $sliderThumbnails.slick('unslick');
        }

        if (window.innerWidth >= 1024 && !$sliderThumbnails.hasClass('slick-initialized')) {
          $sliderThumbnails.slick(sliderThumbnailsOptions);
        }
      };

      /**
       * Slider init function with setting the equal height to the needed elements.
       */
      const sliderInit = () => {
        if (sliderThumbnailsItems.length > 0) {
          const elementsArr = Array.prototype.slice.call(sliderThumbnailsItems);

          elementsArr.forEach((item) => {
            item.addEventListener('click', () => {
              const itemIndex = elementsArr.indexOf(item);

              $slider.slick('slickGoTo', itemIndex);
            });
          });
        }

        $slider.slick(sliderOptions);

        sliderThumbnailsInit();

        window.addEventListener('resize', () => {
          sliderThumbnailsInit();
        });
      };

      sliderInit();

      $(document).ajaxComplete(() => {
        if ($sliderThumbnails.length && $sliderThumbnails.hasClass('slick-initialized')) {
          $sliderThumbnails.slick('setPosition');
        }
      });
    }
  });
})(jQuery);
